import { createSelector } from "reselect";

import type {
  ApplicationConfiguration,
  ApplicationSettings,
  RouteDef,
} from "@superblocksteam/shared";

import { getRoutes } from "legacy/selectors/routeSelectors";
import type { AppState } from "store/types";

export const getCurrentApplication = (state: AppState) => {
  return state.application.wrapper.currentApplication;
};

export const getEnvironment = (state: AppState) =>
  state.application.wrapper.environment;

export const getApplicationSettings = (
  state: AppState,
): ApplicationSettings | undefined =>
  state.application.wrapper?.currentApplication?.settings;

export const selectCurrentApplicationSignatureTree = (state: AppState) =>
  state.application.wrapper?.currentApplicationSignatureTree;

export const getMergedAppConfiguration = createSelector(
  [
    (state: AppState) =>
      state.application.wrapper.currentApplication?.configuration,
    (state: AppState) => getRoutes(state),
  ],
  (
    configuration,
    routes,
  ): ApplicationConfiguration & { routes: Record<string, RouteDef> } => ({
    ...(configuration ?? {}),
    routes,
    dsl: {
      ...(configuration?.dsl ?? { version: 8 }),
    },
  }),
);
